import {
	BaseError,
} from './BaseError';

export class GetCompanyManagersError extends BaseError {
	constructor(message: string, stack?: string) {
		super(message, stack);
	}
}
